import { render, staticRenderFns } from "./AlertInfoBox.vue?vue&type=template&id=bcd17b6e&scoped=true&"
import script from "./AlertInfoBox.vue?vue&type=script&lang=js&"
export * from "./AlertInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./AlertInfoBox.vue?vue&type=style&index=0&id=bcd17b6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd17b6e",
  null
  
)

export default component.exports